import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { colors } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import AccessibleContent from '../../AccessibleContent'

// Create a presentational component for the visual content
const StarBadge = ({ number, label }) => {
  const StreakCountCss = css`
    text-align: center;
    .text,
    .label {
      font-weight: bold;
      display: block;
    }
    .text {
      color: ${colors.yellow80};
      font-size: 300%;
      margin-top: 2rem;
    }
    .label {
      color: ${colors.yellow70};
      font-size: 120%;
    }
  `

  return (
    <div css={StreakCountCss}>
      <span className="text">{number}</span>
      <span className="label">{label}</span>
    </div>
  )
}

StarBadge.propTypes = {
  number: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
}

// The main component
const StreakCount = ({ number, label }) => {
  const { t } = useTranslation()

  // Prepare the screen reader text
  const screenReaderText = t(
    'streaks.total-activities-completed.a11y.label',
    '{count, plural, one {# Activity completed} other {# Activities completed}}',
    {
      count: number,
    }
  )

  return (
    <AccessibleContent accessibleLabel={screenReaderText}>
      <StarBadge number={number} label={label} />
    </AccessibleContent>
  )
}

StreakCount.propTypes = {
  number: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
}

export default StreakCount
